import { useEffect, type ReactNode } from "react";
import { router } from "@inertiajs/react";
import Sidebar from "@/components/Sidebar";
import SidebarResizeHandle from "@/components/SidebarResizeHandle";
import ConnectionBanner from "@/components/ConnectionBanner";
import { Toast } from "@/components/Toast";
import { ActionToast } from "@/components/ActionToast";
import { useSidebar } from "@/stores/sidebar";
import { useReportTimeZone } from "@/hooks/useReportTimeZone";

interface Props {
  children: ReactNode;
}

export default function AppShell({ children }: Props) {
  const { mobileOpen, close: closeMobile, desktopCollapsed } = useSidebar();
  useReportTimeZone();

  useEffect(() => {
    const off = router.on("navigate", () => closeMobile());
    return () => off();
  }, [closeMobile]);

  return (
    <div className="min-h-dvh bg-gray-50 dark:bg-gray-900">
      <ConnectionBanner />
      <Toast />
      <ActionToast />
      <Sidebar />
      <SidebarResizeHandle />
      <button
        aria-label="Закрыть панель"
        className={`sidebar-overlay md:hidden ${mobileOpen ? "open" : ""}`}
        onClick={closeMobile}
      />
      <main className={`main-content ${desktopCollapsed ? "sidebar-collapsed" : ""}`}>
        {children}
      </main>
    </div>
  );
}
